module.exports = __webpack_public_path__ + "img/tips-pre.05a6bb38.png";